import { render, staticRenderFns } from "./BestBuyBannersBlock.vue?vue&type=template&id=38c8d084&scoped=true&"
import script from "./BestBuyBannersBlock.vue?vue&type=script&lang=js&"
export * from "./BestBuyBannersBlock.vue?vue&type=script&lang=js&"
import style0 from "./BestBuyBannersBlock.vue?vue&type=style&index=0&id=38c8d084&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c8d084",
  null
  
)

export default component.exports